var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('Banner'),_c('Service'),_c('Industry'),_c('Cooperate'),_c('Cases'),_c('Customer'),_c('News'),_c('FriendLink'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }